const DEV = false;

const config = {
  API_BASE_URL: DEV
    ? "http://localhost:2001/api/v1/support"
    : "https://api.yozytech.com/api/v1/support",
};

export default config;
